import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { TradeOrgPages } from "../../types/tradeorgPages.ts";

interface Props {
  pageName: TradeOrgPages;
}

// Add case if the logo does not adhere to normal ratio
export const Logo = ({ pageName }: Props) => {
  const { assetsBaseUrl } = useAppConfig();
  switch (pageName) {
    case TradeOrgPages.NBAS:
      return <img src={`${assetsBaseUrl}/assets/${pageName}_logo.png`} alt={`${pageName}-logo`} />;
    default:
      return <img src={`${assetsBaseUrl}/assets/${pageName}_logo.png`} alt={`${pageName}-logo`} className="max-h-48" />;
  }
};
